
import {  useCallback, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import {  ROUTER_PATHS, a11yProps, hasAllPermissions, hasPermission, useCheckPermissions, useTableFilter, useTableServerSideFiltering } from '@/shared';
import { fetchPageNaps, useFetchNaps, useFetchNapsQGIS, useUpdateNaps } from '@/shared/actions/erp';
import {
  CustomSearch,
  FormTabsOnly,
  GeneralTable,
  NestedTabsScene,
  SingleButton,
  SingleIconButton,
  SingleTableBoxScene,
} from '@/shared/components/ui';
import {Naps, NapsQGIS } from '@/shared/interfaces';
import { PermissionsEnum } from '@/auth/interfaces';
import Download from '@mui/icons-material/Download';
import { Tab } from '@mui/material';
import { CustomTabPanel } from '@/erp/sale';
import { useColumnsNaps } from '../../shared/useColumnsNaps';
import ModalGenerarReportesNaps from '../../shared/ModalGenerarReportesNaps';
import { useForm } from 'react-hook-form';
import { Air } from '@mui/icons-material';
import { DesfogueNapsDialog } from '../../shared/DesfogueNapsDialog';

const returnUrlNaps = ROUTER_PATHS.configuracionRED.napsNav;

export interface NapsPageInterface {}

const NapsPage: React.FC<NapsPageInterface> = () => {

  useCheckPermissions(PermissionsEnum.api_view_nap)
  const navigate = useNavigate();
  const [tabNapCurrent, setTabNapCurrent] = useState(1);
  const [openModalReportes, setOpenModalReportes] = useState(false);
  const [openDesfogue, setOpenDesfogue] = useState(false);
  const [currentNap, setCurrentNap] = useState<Naps | null>(null);

  const formModal = useForm({
    defaultValues: {
      naps_desfogue: currentNap?.naps_desfogue || []
    }
  })

  const fetchNaps = useCallback(
    (query: string, page: number) =>
      fetchPageNaps(query, page, { todos: false, estado: true }),
    [], // sin dependencias que cambien
  );

  ///* table
  const {
    globalFilter,
    pagination,
    searchTerm,
    onChangeFilter,
    setPagination,
    cleanFilter
  } = useTableFilter();
  const { pageIndex } = pagination;

  const {
    globalFilter: globalFilterQGIS,
    pagination: paginationQGIS,
    searchTerm: searchTermQGIS,
    onChangeFilter: onChangeFilterQGIS,
    setPagination: setPaginationQGIS,
    cleanFilter: cleanFilterQGIS
  } = useTableFilter();
  const { pageIndex: pageIndexQGIS } = paginationQGIS;
  // filter colums
  const { filterObject, columnFilters, setColumnFilters } = useTableServerSideFiltering();
  
  const { filterObject: filterObjectQGIS, 
    columnFilters: columnFiltersQGIS, 
    setColumnFilters: setColumnFiltersQGIS 
  } = useTableServerSideFiltering();

  const {mutateAsync: updateNaps} = useUpdateNaps({})

  const handleTabChange = useCallback((_: any, value: number) => {
    setTabNapCurrent(value);
    setOpenDesfogue(false);
    setCurrentNap(null);
  }, []);
  const handleOpenDesfogue = useCallback((nap: Naps) => {
    setCurrentNap(nap);
    setOpenDesfogue(true);
  }, []);
    const handleCloseDesfogue = useCallback(() => {
    setOpenDesfogue(false);
    setCurrentNap(null);
  }, []);

  const handleConfirmDesfogue = useCallback(
    async (napsDesfogue: string[]) => {
      if (!currentNap) return;
      await updateNaps({
        id: currentNap.id_nap!,
        data: { naps_desfogue: napsDesfogue && napsDesfogue.length > 0 ? napsDesfogue : null },
      });
      setOpenDesfogue(false);
    },
    [currentNap, updateNaps],
  );

  const renderDesfogueBtn = useCallback(
    (current: Naps) => (
      <SingleIconButton
        startIcon={<Air />}
        label="Desfogue"
        onClick={() => handleOpenDesfogue(current)}
      />
    ),
    [handleOpenDesfogue],
  );
  ///* fetch data
  const {
    data: NapsPagingRes,
    isLoading,
    isRefetching,
  } = useFetchNaps({
    enabled: tabNapCurrent === 1,
    page: pageIndex + 1,
    nombre: searchTerm,
    todos: true,
    ...filterObject,
  });
  
  const {
    data: NapsQGISPagingRes,
    isLoading: isLoadingNapsQGIS,
    isRefetching: isRefetchingNapsQGIS,
  } = useFetchNapsQGIS({
    enabled: tabNapCurrent === 2,
    page: pageIndexQGIS + 1,
    nombre: searchTermQGIS,
    ...filterObjectQGIS,
  }); 
  ///* handlers
   const onEdit = (original: Naps) => {
    navigate(`${returnUrlNaps}/editar/${original.id_nap}`);
  };

  ///* columns
  const {
    columnsNap,
    columnsNapQGIS
  } = useColumnsNaps()



  useEffect(()=>{
    if(!currentNap){
      formModal.setValue('naps_desfogue', [])
    }else{
      formModal.setValue('naps_desfogue', currentNap.naps_desfogue || [])
    }
  },[currentNap])
  useEffect(()=>{
    setColumnFilters([] as any)
    setColumnFiltersQGIS([] as any)
    setOpenDesfogue(false)
    setCurrentNap(null)
  },[tabNapCurrent])
  return (
        <SingleTableBoxScene title="NAP" urlRedirect={`${returnUrlNaps}/crear`} 
        enableRedirect={hasPermission(PermissionsEnum.api_add_nap)} enableDownloadFile={true}
        customContentButtonSide={
            hasPermission(PermissionsEnum.generar_reporte_nap) && (
              <SingleButton
                label="Reporte"
                startIcon={<Download />}
                color='success'
                onClick={() => setOpenModalReportes(true)}
              />
            )
          }
        >
          {/* <Grid item {...gridSizeMdLg12}> */}
          <CustomSearch 
          onChange={(value) => tabNapCurrent === 1 ? onChangeFilter(value) : onChangeFilterQGIS(value)} 
          value={tabNapCurrent === 1 ? globalFilter : globalFilterQGIS} 
          text="Naps" 
          cleanFilter={tabNapCurrent === 1 ? cleanFilter : cleanFilterQGIS}/>
          {/* </Grid> */}
          <NestedTabsScene
            tabs={
              <FormTabsOnly
                onChange={handleTabChange}
                value={tabNapCurrent}
              // justifyContent="flex-end"
              >
                <Tab label="NAPs" value={1} {...a11yProps(1)} />
                <Tab
                  label="Estado Actual NAPs"
                  value={2}
                  {...a11yProps(2)}
                />
              </FormTabsOnly>
            }
          >
            {/* NAPS EVA */}
            <CustomTabPanel index={tabNapCurrent} value={1}>
              <>
                <GeneralTable<Naps>
                  columns={columnsNap}
                  data={NapsPagingRes?.data?.data || []}
                  //
                  isLoading={isLoading}
                  isRefetching={isRefetching}
                  // // search
                  enableGlobalFilter={false}
                  // // pagination
                  pagination={pagination}
                  onPaging={setPagination}
                  rowCount={NapsPagingRes?.data?.count}
                  columnFilters={columnFilters}
                  onColumnFiltersChange={setColumnFilters}
                  // // actions
                  actionsColumnSize={120}
                  enableColumnActions={hasAllPermissions([
                    PermissionsEnum.api_change_nap,
                  ])}
                  enableColumnFilters={true}
                  enableManualFiltering={true}
                  showCustomActionBtnSpace={true}
                  customActionBtnSpace={renderDesfogueBtn}
                  // crud
                  onEdit={onEdit}
                  canEdit={hasAllPermissions([
                    PermissionsEnum.api_change_nap,
                  ])}
                  canDelete={false}
                />
                <DesfogueNapsDialog
                  open={openDesfogue}
                  currentNap={currentNap}
                  onClose={handleCloseDesfogue}
                  onConfirm={handleConfirmDesfogue}
                  fetchNaps={fetchNaps}
                />
              </>
            </CustomTabPanel>
            {/* NAPS QGIS */}
            <CustomTabPanel index={tabNapCurrent} value={2}>
              <GeneralTable<NapsQGIS>
                columns={columnsNapQGIS}
                data={NapsQGISPagingRes?.data?.data || []}
                //
                isLoading={isLoadingNapsQGIS}
                isRefetching={isRefetchingNapsQGIS}
                // // search
                enableGlobalFilter={false}
                // // pagination
                pagination={paginationQGIS}
                onPaging={setPaginationQGIS}
                rowCount={NapsQGISPagingRes?.data?.count}
                columnFilters={columnFiltersQGIS}
                onColumnFiltersChange={setColumnFiltersQGIS}
                enableColumnFilters={true}
                enableManualFiltering={true}
                enableEditing={false}
                // // actions
                // actionsColumnSize={120}
                enableColumnActions={false}
                // crud
                // onEdit={onEdit}
                canEdit={false}
                canDelete={false}
              />
            </CustomTabPanel>
          </NestedTabsScene>
          <ModalGenerarReportesNaps 
            open={openModalReportes} 
            setOpen={setOpenModalReportes} 
          />
        </SingleTableBoxScene>
      );
    };
    export default NapsPage;

